import { ofType } from 'redux-observable';
import {
	mergeMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsApiFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	translateActions,
	notifyActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';

const {
	START_TRANSLATE_TEXTS,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	translateTextsSuccessAction,
	translateTextsFailedAction,
} = translateActions;

export function translateTextsEpic(action$) {
	return action$.pipe(
		ofType(START_TRANSLATE_TEXTS),
		mergeMap(({
			translateKey,
			languageCode,
			texts,
		}) => rxjsApiFetcher
			.post('translate', { languageCode, texts })
			.pipe(
				map(payload => payload.response),
				map(({ data }) => translateTextsSuccessAction({
					translateKey,
					translatedTexts: data,
				})),
				catchError(error => catchErrorForEpics(
					error,
					(err, errorMessage) => translateTextsFailedAction({ error: err, errorMessage, translateKey }),
					notifyErrorAction,
				)),
			),
		),
	);
}
